<table class="table w-100 table-borderless">
  <thead class="border-bottom border-dark">
    <tr>
      <th>{{ 'checkout_summary_description' | i18next }}</th>
      <th>{{ 'checkout_summary_quantity' | i18next }}</th>
      <th>{{ 'checkout_summary_unit_price' | i18next }}</th>
      <th>{{ 'checkout_summary_tax' | i18next }}</th>
      <th>{{ totalLabel | i18next }}</th>
    </tr>
  </thead>
  @for(summary of summaryLines; track summary) {
    <tr class="border-bottom">
      <td>
        @if(summary.price === 0) {
          <div>{{ "checkout_phonenumber_included_phonenumber" | i18next }}</div>
        }
        @if(summary.price > 0) {
          <div>{{ "checkout_phonenumber_addtional_phonenumber" | i18next }}</div>
        }
        <div>{{ translateOrderLineName(summary.name) }}</div>
      </td>
      <td>{{ summary.quantity }}</td>
      <td style="min-width: 90px;">{{summary.price | localized_currency}}</td>
      <td style="min-width: 90px;">
        @if(orderLines?.length) {
          <span>{{orderLines[0].tax}}%</span>
        }
      </td>
      <td style="min-width: 130px;">{{(summary.price * summary.quantity) | localized_currency}}</td>
    </tr>
  }
</table>
